import {suspensionArrayDecoder} from "./decoders";
import {byClientCode} from "../utils";

export const getObservedSuspensions = async () => {
  const response = await fetch(`/api/suspensions/`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw response.statusText
  }

  const json = await response.json()
  const suspensions = suspensionArrayDecoder.runWithException(json)

  return [...suspensions].sort(byClientCode)
}
